<template>
  <div class="relevant-information-table">
    <div class="selection">
      <span class="header">{{$t('relevant_information_table.relevant_information')}}:</span>
      <div class="selection-menu">
        <v-select label="Selection"></v-select>
      </div>
    </div>
    <div class="selection-table">
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.header{
  position: relative;
  top: 20px;
}
.relevant-information-table {
  border-top: solid rgb(25, 118, 210) 2px;
}
.selection {
  font-weight: 800;
  font-size: 16px;
  height: 70px;
  margin-left: 100px;
}
.selection-menu {
  position: absolute;
  top: 0px;
  left: 300px;
  width: calc(100% - 500px);
  height: 30px;
}
.selection-table{
  position: absolute;
  border: solid 1.6px rgb(25, 118, 210);
  left: 150px;
  width: calc(100% - 300px);
  height: calc(100% - 100px);
  overflow: auto;
}
</style>